import { render, staticRenderFns } from "./VendedoresForm.vue?vue&type=template&id=5bf5fbb6&scoped=true&"
import script from "./VendedoresForm.vue?vue&type=script&lang=js&"
export * from "./VendedoresForm.vue?vue&type=script&lang=js&"
import style0 from "./VendedoresForm.vue?vue&type=style&index=0&id=5bf5fbb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf5fbb6",
  null
  
)

export default component.exports